<template>
  <with-actions>
    <div class="row" v-if="can('write_white_label_reports')">
      <div class="col-4">
        <div class="card mb-2">
          <div class="card-header">
            <h2>{{ 'create_new_report' | t }}</h2>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label>{{ 'period_start' | t }}</label>
                  <datetime-picker class="ml-2" v-model="new_report.period_start"></datetime-picker>
                </div>
                <div class="form-group">
                  <label>{{ 'period_end' | t }}</label>
                  <datetime-picker class="ml-2" v-model="new_report.period_end"></datetime-picker>
                </div>
                <button class="btn btn-success" @click="spin($event, create_report)">{{ 'create' | t }}</button>
              </div>
              <div class="col-6">
                <p>{{ 'create_new_report_description' | t }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <lazy-table
      ref="table"
      v-model="reports"
      model="white_label_reports"
      :params="query"
      :autoload="true"
      @meta="(x) => (record_count = x.record_count)"
    >
      <div class="m-3">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>{{ 'id' | t }}</th>
              <th>{{ 'period_start' | t }}</th>
              <th>{{ 'period_end' | t }}</th>
              <th>{{ 'report_status' | t }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-for="report in reports">
            <td>{{ report.id }}</td>
            <td>{{ report.period_start | date }}</td>
            <td>{{ report.period_end | date }}</td>
            <td>{{ report.status }}</td>
            <td>
              <a class="btn btn-primary" v-if="report.download_url" :href="report.download_url">{{ 'download' | t }}</a>
            </td>
          </tbody>
        </table>
      </div>
    </lazy-table>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';
import Alerts, { handle } from '@/utils/alerts';

export default {
  data: function () {
    return {
      reports: [],
      query: {
        sort: '-created_at',
        filter: {}
      },
      record_count: 0,
      new_report: {
        period_start: null,
        period_end: null
      }
    };
  },
  mounted: function () {},
  watch: {
    query: {
      deep: true,
      handler() {
        this.$refs.table.load_debounce(true);
      }
    }
  },
  methods: {
    update_query(q) {
      this.query.filter = q.filter;
    },
    create_report: handle(async function () {
      let { data } = await Api.create('white_label_reports', this.new_report);
      this.reports.unshift(data);
    })
  }
};
</script>
